// extracted by mini-css-extract-plugin
export default {"label":"EditCompound_label__hnRQl","tip":"EditCompound_tip__ey8HF","addTopic":"EditCompound_addTopic__eTk+C"};